export const renderFilterIcon = (columnId: string): boolean => {
  if (columnId === "selection") return false;
  else if (columnId === "action") return false;
  else return true;
};
